module.exports = __webpack_public_path__ + "img/40.cc3ad64c.png";